<template>
  <div class="adapt-box">
    <!-- 动态绑定 iframe 地址 -->
    <iframe :src="targetUrl" frameborder="0" class="adapt-iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: 'IframeAdapt',
  data() {
    return {
      targetUrl: '', // 最终加载的链接
    };
  },
  mounted() {
    this.getAdaptUrl();
  },
  methods: {
    getAdaptUrl() {
      // 判断设备
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );

      // 赋值对应链接
      this.targetUrl = isMobile
        ? 'https://www.hong1fo.com/hyj2026_yd/'
        : 'https://www.hong1fo.com/hyj2026_pc/';
    },
  },
};
</script>

<style scoped>
/* 让 iframe 铺满整个屏幕 */
.adapt-box {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.adapt-iframe {
  width: 100%;
  height: 100%;
  display: block;
}
</style>